import Vue from "vue";
import Vuex from "vuex";
import { ui } from "./ui/ui";
import { shoppingCart } from "./shoppingCart/shoppingCart";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    user_details: {},
    account_details: {},
    token: "",
    logged_in: false,
    loadingState: true,
    errorLoadingState: false,
    monitorsEnabled: false,
    showOrderStatusProgressBar: false,
  },
  getters: {
    user_details: (state) => {
      return state.user_details;
    },
    account_details: (state) => {
      return state.account_details;
    },
    monitorsEnabled: (state) => {
      return state.monitorsEnabled;
    },
    showOrderStatusProgressBar: (state) => {
      return state.showOrderStatusProgressBar;
    }
  },
  mutations: {
    logout(state) {
      state.logged_in = false;
      state.token = "";
      state.user = {};
      state.user_details = {};
      state.account_details = {};
      state.monitorsEnabled = false;
      state.showOrderStatusProgressBar = false;
    },

    auth_success(state, payload) {
      state.logged_in = true;
      state.token = payload.token;
      state.user = payload.user;
      state.user_details = payload.user_details;
      state.account_details = payload.account_details;
      state.monitorsEnabled = process.env.VUE_APP_ENABLE_MONITORS_FOR_SUPER_ADMIN && payload.user_details && payload.user_details.super_admin;
      state.showOrderStatusProgressBar = process.env.VUE_APP_SHOW_PROGRESS_BAR_FOR_SUPER_ADMIN && payload.user_details && payload.user_details.super_admin; 
    },
  },
  actions: {},
  modules: {
    ui,
    shoppingCart,
  },
});
